import { dataModels } from './data-models';
import { requests } from './requests';
import { tables } from './tables';
import { dataFilters } from './data-filters';
import generateColorGradient from './generateColorGradient';

export default {


  usersLabel(businessType) {
    if (businessType) {
      switch (businessType) {
        case 'barrestaurant':
          return 'seats';
        case 'coffeeshop':
          return 'seats';
        case 'officeretail':
          return 'workspaces';
        case 'lodging':
          return 'beds';
        default:
          return 'users';
      }
    }
    return '';
  },

  formatSpeed(speed) {
    if (speed) {
      if (speed >= 1000) {
        return `${speed / 1000} Gbps`;
      } else {
        return `${speed} Mbps`;
      }
    }
    return 'N/A';
  },

  geojsonPolygonToLeaflet(geometry) {
    console.log(`geojsonPolygonToLeaflet: ${geometry.type}`);
    console.log(JSON.stringify(geometry.coordinates, null, '  '));

    if (geometry.type === 'Polygon') {
      // map the rings and coordinates to reversed coordinates
      return geometry.coordinates.map(polyline => polyline.map(coordinate => coordinate.reverse()));
    } else if (geometry.type === 'MultiPolygon') {
      return geometry.coordinates.map(outerRing => outerRing.map(coordinate => coordinate.reverse()));
    }
  },

  applicationModels: dataModels,
  requests,
  tables,
  dataFilters,
  generateColorGradient,
};
